import { render, staticRenderFns } from "./indexinfo.vue?vue&type=template&id=0ff415cb&"
import script from "./indexinfo.vue?vue&type=script&lang=js&"
export * from "./indexinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports